/**
 * Payment-method codes for the `payment_method` column on an order.
 * Kept in sync with the backend order model and the owner dashboard.
 */
export const PAYMENT_METHODS = {
    ONLINE: 1,   // paid by card online at checkout
    IN_STORE: 2, // paid in store (cash/card at the counter)
    AT_VENUE: 3, // deferred — pay at the venue / table-side
};

export const PAYMENT_METHOD_LABELS = {
    [PAYMENT_METHODS.ONLINE]: 'Paid online',
    [PAYMENT_METHODS.IN_STORE]: 'Paid in store',
    [PAYMENT_METHODS.AT_VENUE]: 'Pay at the venue',
};
